import styles from './Language.module.css';
import { useTranslation } from "react-i18next";

const Language = () => {
    const { i18n } = useTranslation();

    const changeLanguage = () => {
        const activeLocale = i18n.resolvedLanguage; 
        activeLocale === "en" ? i18n.changeLanguage("nl") : i18n.changeLanguage("en");
      };
    return (
        <div className={styles.wrapper}>
            <p className={styles.language} onClick={()=> changeLanguage()}>{i18n.resolvedLanguage === "nl" ? "EN": "NL"}</p>
        </div>
    )
}

export default Language;